import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "appFilter" })
export class FilterPipe implements PipeTransform {
	/**
	 * Transform
	 *
	 * @param {any[]} items
	 * @param {string} searchText
	 * @returns {any[]}
	 */
	transform(items: any[], searchText: string): any[] {
		if (!items) {
			return [];
		}
		if (!searchText) {
			return items;
		}
		searchText = searchText.toLocaleLowerCase();
		return items.filter((it) => {
			if (it.description && it.description.toLowerCase().includes(searchText)) {
				return it;
			}
			if (it.displayName && it.displayName.toLowerCase().includes(searchText)) {
				return it;
			}
			if (it.name.toLowerCase().includes(searchText)) {
				return it;
			}
		});
	}
}
